import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
// import {AddDocumentComponent} from "../../../modules/dashboard/home/home-enterprise/document/add-document/add-document.component";

@Component({
  selector: 'app-waring-signature',
  templateUrl: './waring-signature.component.html',
  styleUrls: ['./waring-signature.component.scss']
})
export class WaringSignatureComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<WaringSignatureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onBackClick(){
    this.dialogRef.close();
    // this.data.prev();
  }

  onNextClick(){
    this.dialogRef.close(true);
    this.data.onClickNext();
  }
}
